import { Component } from '@angular/core';

@Component({
  selector: 'app-asset-vehicle-link',
  templateUrl: './asset-vehicle-link.component.html',
  styleUrls: ['./asset-vehicle-link.component.scss']
})
export class AssetVehicleLinkComponent {

}
